import type {
  CheckValidRuleArgs,
  CustomCampaignTargetKey,
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
  PageInfo,
} from "./types";

const createManager = () => {
  const ruleMap = new Map<CustomCampaignTargetKey, ICustomCampaignTargetRule>();

  const result = {
    getDefaultValueList(args: CheckValidRuleArgs) {
      return Array.from(ruleMap.values())
        .filter((def) => def.checkValidRule(args))
        .map((def) => def.getDefaultValue());
    },

    getRule(
      key: CustomCampaignTargetKey
    ): ICustomCampaignTargetRule | undefined {
      return ruleMap.get(key);
    },

    checkValidRule(condition: ICampaignTargetCustom, args: CheckValidRuleArgs) {
      const rule = ruleMap.get(condition.key);
      if (!rule) {
        return false;
      }
      return rule.checkValidRule(args);
    },

    checkPage(condition: ICampaignTargetCustom, pageInfo: PageInfo): boolean {
      const rule = ruleMap.get(condition.key);
      if (!rule) {
        return false;
      }

      return rule.checkPage(condition, pageInfo);
    },

    register: (condition: ICustomCampaignTargetRule) => {
      ruleMap.set(condition.key, condition);
    },
  };
  return result;
};

export default createManager;
